export default __webpack_public_path__ + "static/media/statisticaAreaCommercialeNC.3c8f0516.svg";